export default "__VITE_ASSET__ccdbfacc__"